export enum UrlPathParams {
  RETURN_URL = 'r',
  NO_ACCESS = 'noaccess',
  EXPIRED = 'expired'
}
